import { createApiDeleter, createApiFetcher, createApiPoster, createApiUpdater } from 'src/utils/ApiUtils';
import { IBeneficiary, IBeneficiaryResourceDocument, IBeneMember, IDependent } from 'src/shared/types/Beneficiary';
import { IEducationHistory } from 'src/shared/types/User';
import { EDUCATION_HISTORIES } from 'src/utils/constants/queryKeys';

const Beneficiary = 'beneficiary/';
const Dependent = 'dependent';

const fetchData = createApiFetcher(Beneficiary);
const updateData = createApiUpdater(Beneficiary);
const postData = createApiPoster(Beneficiary);
const deleteData = createApiDeleter(Beneficiary);

export const getBeneficiaryResourceDocument = (caseId: number): Promise<IBeneficiaryResourceDocument[]> =>
  fetchData<IBeneficiaryResourceDocument[]>(`resource-document/${caseId}`);

export const getBeneficiary = (beneId: number): Promise<IBeneficiary> => fetchData<IBeneficiary>(`${beneId}`);

export const getDependents = (beneId: number): Promise<IDependent[]> => fetchData<IDependent[]>(`${beneId}/dependents`);

export const getEducationHistories = (beneId: number): Promise<IEducationHistory[]> =>
  fetchData<IEducationHistory[]>(EDUCATION_HISTORIES, { beneId });

export const addEducationHistory = (data: Record<string, unknown>): Promise<Record<string, unknown>> =>
  postData(EDUCATION_HISTORIES, data);

export const updateEducationHistory = (data: Record<string, unknown>): Promise<Record<string, unknown>> =>
  updateData(EDUCATION_HISTORIES, data);

export const deleteEducationHistory = (id: number): Promise<void> => deleteData<void>(`${EDUCATION_HISTORIES}/${id}`);

export const updateBeneficiaryDetails = (data: Record<string, unknown>): Promise<Record<string, unknown>> =>
  updateData('', data);

export const updateDependentDetails = (data: Record<string, unknown>): Promise<Record<string, unknown>> =>
  updateData(Dependent, data);

export const addNewDependent = async (data: Record<string, unknown>): Promise<IDependent> =>
  postData<IDependent>(Dependent, data);

export const getBeneMembers = async (beneId: number): Promise<IBeneMember[]> =>
  fetchData<IBeneMember[]>(`${beneId}/members`);

export const getRemoteBeneficiaryId = async (beneId: number): Promise<number> =>
  fetchData<number>(`remoteid?beneId=${beneId}`);
